import React from 'react';
import '../../../css/flow-library.less';
import FlowLibraryItems from './FlowLibraryItems';
import translations from '../../translations';

/**
 * @description The root Flow Library component
 *
 * Display a library of example flows of which a user can view details and optionally install.
 */
const FlowLibrary = () => (
    <div className="flow-library">
        <h1>{translations.FL_title}</h1>
        <p>{translations.FL_subtitle}</p>
        <FlowLibraryItems />
    </div>
);

export default FlowLibrary;
